import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
export default {
  name: 'StudentIdentificationSubmitted',
  props: ['item', 'index'],
  data() {
    return {
      action: null,
      errors: {}
    };
  },
  methods: {
    onSubmit(status) {
      const section = 'submitted';
      const p = this.$store.dispatch('subjectids/submit', {
        ...this.item,
        status,
        section
      });
      p.then(response => {
        if (response.message) {
          Swal.fire({
            icon: 'success',
            text: response.message,
            title: 'Success',
            timer: 2000,
            position: 'center',
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        }
        this.$emit('fetch');
        this.action = null;
      });
      p.catch(error => {
        const data = error.responseJSON;
        if (data.errors) {
          this.errors = data.errors;
        }
        this.action = null;
      });
      this.action = 'submit';
      this.errors = {};
    }
  },
  computed: {
    itemImage() {
      return this.item.edited_image_url || this.item.image_url;
    },
    itemType() {
      return this.item.image_type;
    }
  }
};